import type { LocationQuery, RouteLocationRaw } from 'vue-router'

// ADR-109 (27/10/2026): «Báo cáo dự án» là tab `reports` của Dự án › Thực thi (executionWorkspaces.ts). «Bài học kinh nghiệm» là khối thu gọn
// dưới lưới (?section=lessons mở sẵn), «Gửi báo cáo định kỳ» mở từ menu ⋯ trong panel phải (?schedules=1); «Vấn đề & đối sách» về tab
// Theo dõi yêu cầu của chi tiết dự án. Route cũ /reports chuyển hướng tới tab này.

/**
 * Tab cũ (?view=issues|lessons|schedules) và link email/thông báo cũ (?reportId=, ?scheduleId= kể cả &tab=distribution-history) →
 * vị trí mới trong tab «reports» của /execution, giữ các query khác; `null` khi không cần đổi.
 */
export function reportsLegacyLocation(query: LocationQuery): RouteLocationRaw | null {
  const { view, ...rest } = query
  if (view === 'issues') return { path: '/project-registration', query: rest }
  if (view === 'lessons') return { path: '/execution', query: { ...rest, view: 'reports', section: 'lessons' } }
  if (view === 'schedules') return { path: '/execution', query: { ...rest, view: 'reports', schedules: '1' } }
  if (view) return null
  if (typeof query.scheduleId === 'string') return { path: '/execution', query: { ...rest, view: 'reports', schedules: '1' } }
  if (typeof query.reportId === 'string') return { path: '/execution', query: { ...rest, view: 'reports' } }
  return null
}
